/**
 * Property-level repair approval threshold UI helpers.
 * Stored and compared as cents on Property.repairApprovalThreshold.
 */

export const REPAIR_APPROVAL_OPTIONS_CENTS: { value: number; label: string }[] = [
  { value: 0, label: '$0 (all estimates require approval)' },
  { value: 25000, label: '$250' },
  { value: 50000, label: '$500' },
  { value: 100000, label: '$1,000' },
  { value: 250000, label: '$2,500' },
  { value: 500000, label: '$5,000' },
  { value: 1000000, label: '$10,000' },
];

/** Help copy for property edit/create — no company/user-wide language. */
export const REPAIR_APPROVAL_HELP =
  'Property-specific policy. Leave blank for no owner-approval gate. Choose $0 to require approval for every repair estimate. A positive amount requires approval only when the estimate exceeds that threshold (strictly greater than). Values are stored in cents.';

/** Select value: empty string = no gate (null on property). */
export type RepairApprovalSelectValue = number | '';

export function repairApprovalThresholdToSelectValue(
  cents: number | null | undefined,
): RepairApprovalSelectValue {
  if (cents == null || !Number.isFinite(cents)) return '';
  return cents;
}

export function repairApprovalSelectValueToPersist(
  value: RepairApprovalSelectValue,
): number | null {
  if (value === '') return null;
  return value;
}
